import {
	BaseController,
} from '~/utils/base-controller';

/**
 * @implements {angular.IController}
 */
export default class KtableSettings extends BaseController {
	// bindings
	widget;

	/** @type {Dashboard.KTableWidgetOptionsOptions} */
	settings;

	parent;

	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	constructor(
		$injector,
	) {
		super($injector);
	}

	$onInit() {}
}
